import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Server } from "lucide-react";
import { useToast } from "../../components/Toast";

export default function LoginPage() {
  const navigate = useNavigate();
  const push = useToast();
  const [login, setLogin] = useState("ivanov.a");
  const [pwd, setPwd] = useState("••••••••");
  const [show, setShow] = useState(false);

  const onLogin = () => {
    push({ kind: "success", text: "Вход выполнен" });
    navigate("/client");
  };

  return (
    <div className="flex h-full flex-col px-6 py-6">
      <div className="flex flex-1 flex-col items-center justify-center">
        <span
          className="grid h-16 w-16 place-items-center rounded-2xl bg-[var(--color-brand)] text-white shadow-[0_14px_32px_-12px_rgba(31,58,138,0.4)]"
          aria-hidden
        >
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect x="5" y="6" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="2.4" />
            <circle cx="10" cy="14" r="1.5" fill="currentColor" />
            <circle cx="18" cy="14" r="1.5" fill="currentColor" />
          </svg>
        </span>
        <h1 className="mt-5 text-[26px] font-semibold tracking-[-0.01em] text-[var(--color-fg)]">
          АстраМаркет
        </h1>
        <p className="mt-1 text-[13px] text-[var(--color-fg-muted)]">Корпоративные учётные данные</p>

        {/* Локал-сервер */}
        <div className="mt-6 flex w-full items-center gap-3 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface-2)] p-3">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-[var(--color-surface)] text-[var(--color-fg-muted)]">
            <Server size={15} />
          </span>
          <div className="flex-1">
            <div className="font-mono text-[12.5px] font-medium text-[var(--color-fg)]">msk-01.market.corp</div>
            <div className="text-[11px] text-[var(--color-fg-muted)]">Москва · ЦО · В сети</div>
          </div>
          <span className="h-2 w-2 shrink-0 rounded-full bg-[var(--color-success)]" />
        </div>

        {/* Поля */}
        <div className="mt-4 w-full space-y-3">
          <Field label="Логин">
            <input
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2.5 text-[14px] text-[var(--color-fg)] outline-none focus:border-[var(--color-fg-muted)]"
            />
          </Field>
          <Field label="Пароль">
            <div className="relative">
              <input
                type={show ? "text" : "password"}
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2.5 pr-10 text-[14px] text-[var(--color-fg)] outline-none focus:border-[var(--color-fg-muted)]"
              />
              <button
                type="button"
                onClick={() => setShow((v) => !v)}
                className="absolute right-2 top-1/2 grid h-7 w-7 -translate-y-1/2 place-items-center rounded-md text-[var(--color-fg-muted)] hover:bg-[var(--color-surface-2)]"
              >
                {show ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </Field>
        </div>

        <button
          onClick={onLogin}
          className="mt-5 w-full rounded-xl bg-[var(--color-brand)] py-3 text-[14px] font-semibold text-white transition-all hover:bg-[var(--color-navy-700)] active:translate-y-px"
        >
          Войти
        </button>

        <button
          onClick={() => push({ kind: "info", text: "Обратитесь к администратору вашего локального сервера" })}
          className="mt-3 text-[12px] text-[var(--color-fg-muted)] hover:text-[var(--color-fg)]"
        >
          Забыли пароль? Обратитесь к администратору.
        </button>
      </div>
      <div className="text-center font-mono text-[10.5px] text-[var(--color-fg-faint)]">
        v 1.4.0 · protocol 3
      </div>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="text-[11.5px] text-[var(--color-fg-muted)]">{label}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}
